<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Detalle de item</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconEdit"
        @click="editItem"
        >Editar</el-button
      >
      <el-button
        type="primary"
        size="default"
        :icon="IconContentCopy"
        @click="duplicateItem"
      >
        Duplicar
      </el-button>
      <home-delete-button></home-delete-button>
    </template>
  </main-buttons-bar>

  <detail-container>
    <el-row :gutter="20">
      <custom-data
        :label="'Fecha creacion'"
        :spanColumn="4"
        :data="material.FechaCreacion ? getDate('dd/mm/yyyy', material.FechaCreacion) : ''"
      ></custom-data>
      <custom-data
        :label="'Fecha actualización'"
        :spanColumn="4"
        :data="
          material.FechaActualizacion ? getDate('dd/mm/yyyy', material.FechaActualizacion) : ''
        "
      ></custom-data>
      <custom-data
        :label="'Código'"
        :spanColumn="4"
        :data="material ? material.Codigo : ''"
      ></custom-data>
      <custom-data
        :label="'Activo'"
        :spanColumn="3"
        :data="material.Activo ? 'Si' : 'No'"
      ></custom-data>
      <custom-data
        :label="'Código Adicional'"
        :spanColumn="4"
        :data="material && material.CodigoAdicional ? material.CodigoAdicional : '-'"
      ></custom-data>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <custom-data
        :label="'Tipo item'"
        :spanColumn="4"
        :data="
          material && material.MaterialTipo && material.MaterialTipo.Descripcion
            ? material.MaterialTipo.Descripcion
            : '-'
        "
      ></custom-data>
      <custom-data
        v-if="material.MaterialTipo?.Fibra"
        :label="'Orientación de fibra'"
        :spanColumn="4"
        :data="orientacionDescripcion"
      />
      <custom-data
        :label="'Moneda'"
        :spanColumn="4"
        :data="material ? material.Moneda.Descripcion : '-'"
      ></custom-data>
      <custom-data
        :label="'Unidad medida'"
        :spanColumn="4"
        :data="material ? material.UnidadMedida.Descripcion : '-'"
      ></custom-data>
      <custom-data
        :label="'Descripción Interna'"
        :spanColumn="8"
        :data="material && material.DescripcionInterna ? material.DescripcionInterna : ''"
      ></custom-data>
      <custom-data
        :label="'Descripción visible al cliente'"
        :spanColumn="8"
        :data="material && material.DescripcionCliente ? material.DescripcionCliente : '-'"
      ></custom-data>
      <custom-data
        :label="'Descripción para reportes y rótulos'"
        :spanColumn="8"
        :data="material && material.DescripcionReporte ? material.DescripcionReporte : '-'"
      ></custom-data>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <custom-data
        :label="'Unidad medida secundaria'"
        :spanColumn="4"
        :data="material ? material.UnidadMedida.Descripcion : '-'"
      ></custom-data>
      <custom-data
        :label="'Factor conversion'"
        :spanColumn="4"
        :data="material && material.FactorConversion ? material.FactorConversion : 'No especifica'"
      ></custom-data>
      <custom-data
        :label="'Tiempo entrega'"
        :spanColumn="4"
        :data="material && material.TiempoEntrega ? material.TiempoEntrega : 'No especifica'"
      ></custom-data>
      <custom-data
        :label="'Codigo proveedor'"
        :spanColumn="4"
        :data="material && material.CodigoProveedor ? material.CodigoProveedor : 'No especifica'"
      ></custom-data>
      <custom-data
        :label="'Exacto'"
        :spanColumn="3"
        :data="material.Exact ? 'Si' : 'No'"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Familia item'"
        :spanColumn="12"
        :data="
          material && material.MateriaPrimaFamilia && material.MateriaPrimaFamilia.Descripcion
            ? material.MateriaPrimaFamilia.Descripcion
            : '-'
        "
      ></custom-data>
    </el-row>
    <el-divider></el-divider>

    <el-row :gutter="20">
      <el-col
        v-for="(field, index) in dynamicDetailFields"
        :key="index"
        :span="4"
      >
        <custom-data
          :label="field.label"
          :data="field.value"
        ></custom-data>
      </el-col>
    </el-row>
  </detail-container>
</template>

<script setup>
import {
  onBeforeMount,
  computed,
  ref,
} from 'vue';
import { useMaterialStore } from '@/stores/materiales_store.js';
import { storeToRefs } from 'pinia';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomData from '@/shared/components/custom_data.vue';
import IconEdit from '~icons/mdi/edit';
import getDate from '@/shared/components/utils.js';
import IconContentCopy from '~icons/mdi/content-copy';
const materialStore = useMaterialStore();

const { findMaterialByCodigoHTTP } = materialStore;
const { material } = storeToRefs(materialStore);
const route = useRoute();
const router = useRouter();
const modalDuplicateVisible = ref(false);
const orientOptions = [
  { Codigo: 0, Descripcion: 'Sin orientación' },
  { Codigo: 1, Descripcion: 'Larga' },
  { Codigo: 2, Descripcion: 'Corta' },
];

// Computed que devuelve la Descripcion según material.OrientacionFibra
const orientacionDescripcion = computed(() => {
  const o = orientOptions.find((o) => o.Codigo === material.value.OrientacionFibra);
  return o ? o.Descripcion : 'Sin orientación';
});

const dynamicDetailFields = computed(() => {
  const mt = material.value.MaterialTipo;
  // Si no hay tipo seleccionado, no se muestran campos dinámicos
  if (!mt) return [];
  const fields = [
    {
      prop: 'Ancho',
      label: 'Ancho',
      show: typeof mt.Ancho === 'number' && mt.Ancho !== 0,
      value: material.value.Ancho,
    },
    {
      prop: 'Alto',
      label: 'Alto',
      show: typeof mt.Alto === 'number' && mt.Alto !== 0,
      value: material.value.Alto,
    },
    {
      prop: 'Largo',
      label: 'Largo',
      show: typeof mt.Largo === 'number' && mt.Largo !== 0,
      value: material.value.Largo,
    },
    {
      prop: 'Espesor',
      label: 'Espesor',
      show: typeof mt.Espesor === 'number' && mt.Espesor !== 0,
      value: material.value.Espesor,
    },
    {
      prop: 'Gramaje',
      label: 'Gramaje',
      show: typeof mt.Gramaje === 'number' && mt.Gramaje !== 0,
      value: material.value.Gramaje,
    },
    {
      prop: 'Densidad',
      label: 'Densidad',
      show: typeof mt.Densidad === 'number' && mt.Densidad !== 0,
      value: material.value.Densidad,
    },
    {
      prop: 'Diametro',
      label: 'Diametro',
      show: typeof mt.Diametro === 'number' && mt.Diametro !== 0,
      value: material.value.Diametro,
    },
    {
      prop: 'Rendimiento',
      label: 'Rendimiento',
      show: typeof mt.Rendimiento === 'number' && mt.Rendimiento !== 0,
      value: material.value.Rendimiento,
    },
  ];
  return fields.filter((f) => f.show);
});

// local state
const items = [
  { label: 'Inicio', to: '/page/material/list', replace: false },
  { label: 'Detalle', to: null, replace: false },
];

const editItem = () => router.replace(`/page/material/edit/${route.params.id}`);

function duplicateItem() {
  const copy = JSON.parse(JSON.stringify(material.value));
  copy.Descripcion = null;
  if (!copy.MateriaPrimaFamilia) {
    copy.MateriaPrimaFamilia = { Descripcion: '' };
  }
  Object.assign(material.value, copy);
  modalDuplicateVisible.value = true;
}

onBeforeMount(() => {
  const id = route.params.id;
  if (id && +id > 0) {
    findMaterialByCodigoHTTP(id);
  }
});
</script>

<style scoped></style>
